/* unplugin-vue-components disabled */import script from "./DnaHelix.vue?vue&type=script&setup=true&lang=js"
export * from "./DnaHelix.vue?vue&type=script&setup=true&lang=js"

import "./DnaHelix.vue?vue&type=style&index=0&id=f9ec4216&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f9ec4216"]])

export default __exports__